import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "style.css";
import "tailwindcss/lib/css/preflight.css";
import MainLandingPage from "pages/MainLandingPage";
import PrivacyPolicy from "pages/PrivacyPolicy";
import PrivacyPolicyMatomeLife from "pages/PrivacyPolicyMatomeLife";
import PrivacyPolicyFootballLife from "pages/PrivacyPolicyFootballLife";
import PrivacyPolicyBaseballLife from "pages/PrivacyPolicyBaseballLife";
import NotFound from "pages/NotFound";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<MainLandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
          <Route path="/matome-life/privacy-policy" element={<PrivacyPolicyMatomeLife />}/>
          <Route path="/football-life/privacy-policy" element={<PrivacyPolicyFootballLife />}/>
          <Route path="/baseball-life/privacy-policy" element={<PrivacyPolicyBaseballLife />}/>
        </Routes>
      </Router>
    </>
  );
}

export default App;